<template>
  <section class="movie-block" v-if="showBanner">
    <div class="container-fluid">
      <div class="row justify-content-between">
        <div class="col-md-6">
          <p class="pb-4">
            <img :src="bgImg2" width="300" alt="" />
          </p>
          <p class="text-dark">{{ bannerData.description }}</p>
          <p class="text-dark">Starring: {{ getActors() }}</p>
          <p>
            <a class="btn btn-lg btn-primary" @click="playvideo(bannerData)"
              >Watch Now</a
            >
            <a
              @click="toggleFavorited(bannerData)"
              class="btn btn-lg btn-outline-primary ml-2"
              ><img
                class="icon1"
                src="../assets/img/minus-green.svg"
                v-if="my_favourite(bannerData)"
              />
              <img class="icon1" src="../assets/img/plus-green.svg" v-else />
              {{ FavTitle }}</a
            >
          </p>
        </div>
        <div class="col-md-6">
          <img :src="bgImg1" class="img-fluid" />
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.btn-primary {
  color: #f1f2f2 !important;
}
</style>

<script>
export default {
  name: "Header",
  props: ["title", "apiOptions"],
  methods: {
    goToDetails(current) {
      var dynamicRoute = "";
      if (current.type == "vod") {
        dynamicRoute = "/#/details/" + "/" + this.apiOptions;
      } else if (current.type == "Season") {
        dynamicRoute = "/#/playlistdetails/" + this.apiOptions;
      }
      return dynamicRoute;
    },

    playvideo(current) {},

    playvideo(current) {
      this.checkSubs(current);
    },

    checkSubs(current) {
      this.$store.dispatch("getVideoById", current.id).then((res) => {
        this.video_name = res._embedded.collections[0].name;
        this.$store
          .dispatch("getVideoPlaybackURLV2", {
            videoId: current.id,
            deviceId: this.duidVal,
          })
          .then((res) => {
            var currentCat = current.id;
            var dynamicRoute = "/viewvideo/" + current.id;
            this.$router.push("" + dynamicRoute);
          })
          .catch((err) => {
            if (err.response.data.error.status == "422") {
              // show upgrade screen popup
            }
            if (err.response.data.error.status == "403") {
              this.$store.commit("showdefaultFooter", false);
              this.$store.commit("showPopup", true);
              window.scrollTo(0, 0);
            }
            if (err.response.data.error.status == "404 ") {
              this.$store.commit("showPopup", true);
            //this.$store.commit("setNotification", "Please try again later ");
            window.scrollTo(0, 0);
          }
            this.$store.commit("setLoader", false);
          });
      });
    },

    getActors() {
      return this.bannerData.metaData.Starring;
    },

    my_favourite(show) {
      for (var i = 0; i < this.$store.state.user.mylist.length; i++) {
        var item = this.$store.state.user.mylist[i];
        if (item.id == show.id) return true;
      }
      return false;
    },
    toggleFavorited(show) {
      this.$store.commit("refreshMyList", false);
      if (this.my_favourite(show)) {
        this.$store
          .dispatch("updatemyList", {
            id: show.id,
            value: false,
            type: show.type,
          })
          .then(() => {
            // this.$store.commit("refreshMyList" ,true)
          });
      } else {
        this.$store
          .dispatch("updatemyList", {
            id: show.id,
            value: true,
            type: show.type,
          })
          .then(() => {
            //this.$store.commit("refreshMyList" ,true)
          });
      }
    },
  },
  computed: {
    FavTitle() {
      if (this.my_favourite(this.bannerData)) {
        return "Remove from List";
      } else {
        return "Add to List";
      }
    },
    
  },
  data() {
    return {
      bannerData: null,
      showBanner: false,
      bgImg1: "https://www.ibakatv.com/_nuxt/img/62cf189.jpg",
      bgImg2: "https://www.ibakatv.com/_nuxt/img/62cf189.jpg",
      duidVal:null
    };
  },
  created() {
    this.showBanner = false;
    this.$store.commit("showPopup", false);
    this.$store.dispatch("getCatalougeById", this.apiOptions).then((res) => {
      this.bannerData = res._embedded.items[0];
      if(this.bannerData.languages[1].thumbnail){
        this.bgImg1 = this.bannerData.languages[1].thumbnail.large;
      }
      
      if(this.bannerData.metaData.bannerImage){
      this.bgImg2 = this.bannerData.metaData.bannerImage;
      }
      this.showBanner = true;
    });
  },
};
</script>
